import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import colors from '@app/constants/colors';
import RouterConstants from '@app/constants/router';
import { Button } from '@app/components';

const WatchSection = ({ isSubscriptionActive }) => (
  <Section>
    <Wrapper>
      <Image src="/images/home-shows.png" alt="shows" />
      <SectionContent>
        <h1><FormattedMessage id="home.introSection2.title" /></h1>
        <p><FormattedMessage id="home.introSection2.paragraph" /></p>
        <p><FormattedMessage id="home.introSection2.list1" /></p>
        <p><FormattedMessage id="home.introSection2.list2" /></p>
        <p><FormattedMessage id="home.introSection2.list3" /></p>
      </SectionContent>
      {!isSubscriptionActive && (
        <Button
          wide
          bordered
          labelId="home.join"
          textColor={colors.SANDWISP}
          backgroundColor={colors.BUTTERFLY_BUSH}
          path={RouterConstants.SUBSCRIBE}
        />
      )}
    </Wrapper>
  </Section>
);

WatchSection.propTypes = {
  isSubscriptionActive: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ subscribe: { isSubscriptionActive } }) => ({
  isSubscriptionActive,
});

export default connect(mapStateToProps)(WatchSection);

const Section = styled.section`
  background: linear-gradient(180deg, ${colors.ATLANTIS}, ${colors.CAPER});
  padding: 0 20px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  max-width: 1120px;
  padding: 70px 0px 50px;
  & p:not(:first-of-type) {
    margin: 0.5em 0;
  }
  & p:last-child {
    margin-bottom: 30px;
  }
  @media (max-width: 979px) {
    padding: 40px 0;
  }
`;

const Image = styled.img`
  max-width: 100%;
  height: auto;
`;

const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  text-align: center;
  max-width: 740px;
  & h1, & p {
    color : ${colors.BUTTERFLY_BUSH};
  }
`;
